import React from "react"
import PropTypes from "prop-types"
import Icon from "../icon"
import IconButtonBase from "./icon-button-base"

/**
 * @param {Object} props
 * @param {string} props.icon Icon name from the design system icon library
 */
const IconButton = React.forwardRef(
  ({ icon, ...props }, ref) => {
    return (
      <IconButtonBase {...props} ref={ref}>
        <Icon name={icon} className="pointer-events-none" />
      </IconButtonBase>
    )
  }
)

IconButton.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  className: PropTypes.string
}

export default IconButton
